
import { getUserTypeFromUrlLs } from './useUserInfo';

const getConfig = ({domain="", protocol=""}) => {

  let userPoolId = "us-east-1_9QPVGsLAP";
  let userPoolWebClientId = "6b83igif6656o7a07jvisv18os";
  let identityPoolId = "us-east-1:972add6b-c3f2-422d-901e-9b0bc50ee943";
  let userType = "customer";

  if (typeof window !== "undefined") {
    const {
      isInteriorDesigner,
      isProductSupplier,
      isCampaign,
    } = getUserTypeFromUrlLs();

    localStorage.removeItem("ai-user-type");
    if (isInteriorDesigner) {
      userPoolId = "us-east-1_yMZBfZQqV";
      userPoolWebClientId = "7gtvsv667v91rmcast42k0n1fm";
      identityPoolId = "us-east-1:e237aed2-b53f-415a-8ae2-06429ab611fb";
      userType = "designer";
      localStorage.setItem("ai-user-type", "designer");
    }

    if (isProductSupplier) {
      userPoolId = "us-east-1_yMZBfZQqV";
      userPoolWebClientId = "2l2os9songt95ugi3o70dpkssl";
      identityPoolId = "us-east-1:ec21ff77-39b3-4ef4-bce5-a4d56e1d5581";
      userType = "supplier";
      localStorage.setItem("ai-user-type", "supplier");
    }
  }
  console.log("getConfig: domain: ", domain, "protocol: ", protocol, "userType: ", userType);
  
  let config;
  if (userType === "customer") {
    config = {
      userType,
      Auth: {
        region: "us-east-1",
        userPoolId,
        userPoolWebClientId,
        identityPoolId,
        oauth: {
          domain: '//auth.nestingale.com',
          scope: ['phone', 'email', 'openid', 'profile'],
          redirectSignIn: protocol + "://" + domain + "/auth-callback",
          redirectSignOut: protocol + "://" + domain + "/login",
          responseType: 'code',
          providers: ['Google', 'Apple']
        }
      }
    };
  } else {
    config = {
      userType,
      Auth: {
        region: "us-east-1",
        userPoolId,
        userPoolWebClientId,
        identityPoolId,
      }
    };
  }
  return config;
}



export default getConfig